/**
 * P41 · point 6 — "Who represents me", inside the student's profile.
 *
 * Hangs off `/profile` and not `/profile/academic` because it isn't an academic
 * record: it's who has their data and what they get to see. Same family as
 * `/profile/delete-account` — things the person has a right to look at and
 * move regarding their own account.
 */
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { MyGuardianshipView } from "@/features/academy/components/consent/my-guardianship-view";

export const profileGuardianshipRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/profile/guardianship",
  component: MyGuardianshipView,
});
